import { useEffect } from 'react';
import { useContent } from '@/lib/content';
import { Reveal } from '@/components/Reveal';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { WhatsAppFloat } from '@/components/WhatsAppFloat';
import { CalculatorCard } from '@/components/CalculatorCard';

export default function BirthdayCalculator() {
  const { loaded } = useContent();

  useEffect(() => {
    document.title = 'Birthday Decoration Price Calculator | Events by AJ Hyderabad';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-ink text-cream min-h-screen">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main className="pt-28 sm:pt-36 pb-24">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <Reveal className="text-center">
            <p className="caption-label mb-4">Instant Estimate</p>
            <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl font-light tracking-tight text-cream">
              Birthday Decor <span className="italic text-champagne">Calculator</span>
            </h1>
            <p className="mt-6 text-base md:text-lg text-white/60 font-light leading-relaxed max-w-xl mx-auto">
              Choose your decor style, tell us your stage length, and see an instant estimate
              with everything that&rsquo;s included.
            </p>
          </Reveal>
          {loaded && (
            <Reveal delay={0.15} className="mt-12">
              <CalculatorCard />
            </Reveal>
          )}
        </div>
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
